import { Injectable } from '@angular/core';

import { Observable, ReplaySubject, Subject } from 'rxjs';

import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  private fromNavbarSubject = new Subject<any>();
  private fromProjectsPageSubject = new ReplaySubject<any>();

  constructor() {}

  /* Communication from navbar to projects list component */

  rebuildNavbar() {
    this.fromNavbarSubject.next({ text: 'rebuild' });
  }

  getMessageFromNavbar(): Observable<any> {
    return this.fromNavbarSubject.asObservable();
  }

  /* Communication from projects list component to navbar */

  projectListComponentTooltip(tooltip: string) {
    this.fromProjectsPageSubject.next({ infoTooltip: tooltip });
  }

  getMessageFromProjectsPage(): Observable<any> {
    return this.fromProjectsPageSubject.asObservable();
  }
}
